import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import { BrowserRouter as Router, Route } from "react-router-dom"
import "./index.css"
import App from "./App"
import PbgThemeProvider from "./components/ThemeProvider"
import ErrorBoundary from "./components/ErrorBoundary"
import * as serviceWorker from "./serviceWorker"
import { store } from "./store"
import { Auth0Provider } from "./react-auth0-wrapper"
import history from "./lib/history"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"

// A function that routes the user to the right place
// after login
const onRedirectCallback = appState => {
  history.push(
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname
  )
}

const render = () =>
  ReactDOM.render(
    <ErrorBoundary>
      <GoogleReCaptchaProvider
        reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY}
      >
        <Provider store={store}>
          <Router>
            <Auth0Provider
              domain={process.env.REACT_APP_AUTH_DOMAIN}
              client_id={process.env.REACT_APP_AUTH_CLIENTID}
              redirect_uri={window.location.origin}
              onRedirectCallback={onRedirectCallback}
              audience={process.env.REACT_APP_AUTH_AUDIENCE}
              useRefreshTokens={true}
            >

              <PbgThemeProvider>
                <Route path="*" component={App} />
              </PbgThemeProvider>
            </Auth0Provider>
          </Router>
        </Provider>
      </GoogleReCaptchaProvider>
    </ErrorBoundary>,
    document.getElementById("root")
  )
render()

store.subscribe(render)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
